import { useLocalization } from "@fluent/react";
import cc from "classcat";
import styles from "./SettingsBanner.module.scss";
import { useIsSidebarEnabled } from "../../../src/modules/sidebar/sidebar.hooks";

const SettingsBanner = () => {
  const { l10n } = useLocalization();
  const { isSidebarEnabled } = useIsSidebarEnabled();
  const contentClass = cc([
    styles.content,
    !isSidebarEnabled && styles.contentWithBackground,
  ]);
  return (
    <div className={styles.banner}>
      <div className={contentClass}>
        <h1 className={styles.title}>{l10n.getString("heading-settings")}</h1>
      </div>
    </div>
  );
};

export default SettingsBanner;
